module.exports = __webpack_public_path__ + "img/latest_news_icon.7911fed4.svg";